module.exports = __webpack_public_path__ + "static/media/home-slide4.f47a7089.webp";